<template>
    <div  class=" transition-all	 test flex flex-col fixed top-0 left-0 w-screen h-screen  items-center justify-center  z-50 bg-[#00000063] backdrop-blur-[2px]  text-lg  ">
        <div :class="[{'border-[#12760A]': success ,'border-[#AB0000]': !success }]" class=" max-lg:w-[90%] w-[700px]  2xl:w-[700px] rounded-lg border-[2px]  bg-white z-50 ">
            <div :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class=" flex flex-col items-center py-10 gap-3 shadow-2xl">
                <div>
                    <ErrorLogo/>
                    <QuestionLogo v-show="false"/>           
                </div>
                <p class="font-semibold text-white text-xl tracking-wide mx-5 text-center max-lg:">{{ header }}</p>
                <p class="text-white text-sm mx-5 text-center" name="error">{{ header1 }}</p>
 
            </div>
            <div class="h-[80px] flex justify-center items-center gap-5 ">
                <div class="flex gap-10">
                    <button :class="{'bg-[#12760A]': success ,'bg-[#AB0000]': !success ,}" class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px]" @click="$emit('close')" >Close</button>
                    <!-- <button  class="px-9 py-3 text-sm text-white rounded-full shadow-2xl w-[150px] bg-[#9da09d]" @click="$emit('cancel')">Cancel</button> -->
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { defineComponent } from "vue"
import QuestionLogo from "./PromptSvg/QuestionLogo.vue"
import ErrorLogo from "./PromptSvg/ErrorSvg.vue"
export default defineComponent({
    components:{
        QuestionLogo,
        ErrorLogo,
    },
    data(){
        return{
        }
    },
    props:{
        header:{
            type:    String,
            default: null,
        },
        header1:{
            type:    String,
            default: null,
        },
        success:{
            type: Boolean,
            default: null,
        },
    },
    mounted(){
    
    },
    methods:{
       
    }

})

</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 10s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>